import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import CONFIG from '../../config'
import Link from '../controls/Link'
import Logo from '../../../assets/images/logo/b_badge_stroked_dark.png'
import Logotype from '../../../assets/images/logo/blok_logotype@2x.png'

class TopNav extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  static styles = () => ({
    logo: {
      height: 72,
    },
    logotype: {
      height: 72,
    },
  })

  render() {
    const { classes } = this.props

    return (
      <Link to={CONFIG.blokable.marketingBaseUrl}>
        <img src={Logo} alt="Blokable" className={classes.logo} />
        <img src={Logotype} alt="Blokable" className={classes.logotype} />
      </Link>
    )
  }
}

export default withStyles(TopNav.styles)(TopNav)
